import React from 'react';
import { PortableText } from '@portabletext/react';
import {
  SanityCta,
  SanityImgAlt,
  SanityPage,
  SanityPageExpertise,
  SanityPageProduct,
} from 'graphql-types';
import { constructSlug } from '../../../utils/constructSlug';
import { replaceKoreanAddressInObject } from '../../../utils/replaceKoreanAddress';
import { usePageContext } from '../../context/pageContext';
import { CTA } from '../../html-tag/Cta';
import * as styles from './blocks.module.scss';

interface Props {
  blocks: any;
}

export const Blocks = ({ blocks }: Props) => {
  const { lang } = usePageContext();

  // Apply Korean address replacement to all blocks content
  const processedBlocks = replaceKoreanAddressInObject(blocks);

  return (
    <PortableText
      value={processedBlocks}
      components={{
        block: {
          h134: ({ children }) => {
            return <h1 className={styles.customh1}>{children}</h1>;
          },
        },
        types: {
          cta: ({ value }) => {
            const button: SanityCta = value;
            const label = Array.isArray(button?.label)
              ? button?.label?.find((item) => item?.language === lang)?.text
              : button?.label?.[lang];

            let slug;
            if (button.destinationCta === 'external') slug = button.urlCta;
            else
              slug = constructSlug({
                destination: button.slugCta as SanityPage | SanityPageExpertise | SanityPageProduct,
              });

            return (
              <div className={styles.marginBlock}>
                <CTA
                  label={label ?? ''}
                  dataType={button?.colorCta ?? ''}
                  to={slug}
                  target={button?.targetCta ?? ''}
                  reverse={button?.activeReverse ?? false}
                />
              </div>
            );
          },
          imgAlt: ({ value }) => {
            const image: SanityImgAlt = value;
            return (
              <img
                alt={image?.alt ?? ''}
                src={image?.img?.asset?.url ?? ''}
                style={{ maxHeight: '100px', maxWidth: '80%', marginBottom: '2rem' }}
              />
            );
          },
          phoneNumberLink: ({ value }) => {
            const phoneNumberLink = value;
            const number = phoneNumberLink.phoneNumber;
            return (
              <a
                className={styles.phoneLink}
                href={`tel:${number}`}
              >
                {number}
              </a>
            );
          },
        },
        marks: {
          color: ({ children, value }) => {
            return (
              <div
                style={{
                  color: `rgba(${value?.rgb?.r},${value?.rgb?.g}, ${value?.rgb?.b}, ${value?.rgb?.a})`,
                  display: 'inline',
                  fontWeight: 700,
                }}
              >
                {children}
              </div>
            );
          },
        },
      }}
    />
  );
};
